import { render, staticRenderFns } from "./ThirdPartyForm.vue?vue&type=template&id=8e8c4b8c&scoped=true&"
import script from "./ThirdPartyForm.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyForm.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyForm.vue?vue&type=style&index=0&id=8e8c4b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8c4b8c",
  null
  
)

export default component.exports